import { createSlice } from '@reduxjs/toolkit'
import { checkPermission } from 'src/utils/commonUtils'

const initialState = {
  sidebarShow: true,
  sidebarUnfoldable: false,
  isAdmin: checkPermission(),
}

export const toggleState = createSlice({
  name: 'toggleState',
  initialState,
  reducers: {
    toggleSideBar: (state, action) => {
      state.sidebarShow = action.payload
    },
    toggleUnfoldable: (state) => {
      state.sidebarUnfoldable = !state.sidebarUnfoldable
    },
    toggleIsAdmin: (state) => {
      state.isAdmin = checkPermission()
    },
  },
})

export const { toggleSideBar, toggleUnfoldable, toggleIsAdmin } = toggleState.actions

export default toggleState.reducer
